<div class="container mt-4">
  <div class="row">
    <div class="col-md-12">
      <h1 class="text-center">Assinatura Concluída</h1>
      <p class="text-center">Sua assinatura foi concluída com sucesso!</p>
      <p class="text-center">Obrigado por utilizar nossos serviços.</p>
    </div>
  </div>
  <div class="row">
   
  </div>

</div>
